<script lang="ts">
  import { _ } from 'svelte-i18n';
  import ForecastJourneyChart from './ForecastJourneyChart.svelte';
  import { journeyActual, journeyLabel, journeyMetricsOf, journeyScale, journeyTarget, journeyUnit } from './report';

  /* eslint-disable @typescript-eslint/no-explicit-any */
  export let report: any;

  let journeyMetric: string | null = null;
  $: journeyMetrics = journeyMetricsOf(report);
  $: if (journeyMetrics.length && (!journeyMetric || !journeyMetrics.includes(journeyMetric))) journeyMetric = journeyMetrics[0];
  $: label = (m: string) => journeyLabel(report, m);
  $: scale = journeyScale(journeyMetric);
  $: unit = journeyUnit(journeyMetric);
  $: target = journeyTarget(report, journeyMetric);
  $: actual = journeyActual(report, journeyMetric);
</script>

  {#if journeyMetrics.length && report.forecast_history?.versions?.length > 1}
    <section class="mb-6 rounded border border-zinc-200 bg-white p-4">
      <h2 class="text-lg font-semibold mb-1">{$_('report.journey.heading')}</h2>
      <p class="text-sm text-zinc-500 mb-3">{$_('report.journey.intro')} {report.forecast_history.segments.length > 1 ? $_('report.journey.moved') : ''}</p>
      <div class="flex flex-wrap gap-2 mb-2">
        {#each journeyMetrics as m}
          <button class="px-3 py-1 rounded-full text-sm border {journeyMetric === m ? 'bg-zinc-800 text-white border-zinc-800' : 'bg-white text-zinc-600 border-zinc-300'}" aria-pressed={journeyMetric === m} on:click={() => (journeyMetric = m)}>{label(m)}</button>
        {/each}
      </div>
      <ForecastJourneyChart versions={report.forecast_history.versions} segments={report.forecast_history.segments} metric={journeyMetric ?? ''} {unit} {scale} {target} {actual} />
    </section>
  {:else}
    <section class="mb-6 rounded border border-zinc-200 bg-white p-4">
      <h2 class="text-lg font-semibold mb-1">{$_('report.journey.heading')}</h2>
      <p class="text-sm text-zinc-500">{$_('report.journey.saved_once')}{report.plan_updates?.length ? ' ' + $_('report.journey.replaced') : ''}</p>
    </section>
  {/if}
